module.exports = {"120110001":"张贵庄街道","120110002":"丰年村街道","120110003":"万新街道","120110004":"无瑕街道","120110005":"新立街道","120110006":"华明街道","120110007":"金钟街道","120110008":"军粮城街道","120110009":"金桥街道","120110010":"华新街道","120110011":"东丽湖街道","120110400":"天津开发区西区","120110401":"天津航空物流区","120110402":"天津空港经济区","120110403":"东丽区经济技术开发区","120110405":"综合保税区","120110406":"航空新城","120110407":"服务滨海新区建设管理委员会"}


//////////////////
// WEBPACK FOOTER
// ./src/town/120110.json
// module id = 46
// module chunks = 0